const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the manual completion component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {ScormRegistrations} ScormRegistrations the resource defined to manage ScormRegistrations

 */
app.directive('manualCompletion', ['Application', 'ScormRegistrations', 'Assignments', 'UserTracks', '$translate', function(Application, ScormRegistrations, Assignments, UserTracks, $translate) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        type: '@',
        content: '=',
        show: '=',
        postSubmit: '&'
      },
      template: require('../../templates/directives/manual-completion.html'),
      controller: ['$scope', function($scope) {
        var self = this;
        self.translations = {};
        var submission = function() {
          const completedDate = moment(self.dateInfo.date, self.dateInfo.momentFormat).toISOString();
          switch($scope.type) {
            case 'assignment':
              return Assignments.manualComplete({subresource: $scope.content._id}, {completedDate}).$promise;
            case 'scorm':
              return ScormRegistrations.manualComplete({subresource: $scope.content.id}, {completedDate}).$promise;
            case 'track':
              return UserTracks.manualComplete({subresource: $scope.content._id}, {completedDate}).$promise;
          }
        };
        self.today = new Date();
        self.dateInfo = {
          datepickerFormat: Application.dateFormatting.getWorkshopPickerFormat(),
          momentFormat: Application.dateFormatting.getMomentFormat(),
          today: moment(new Date()).format(this.momentFormat),
          date: '',
          validateDate: () => {
            const date = self.dateInfo.date;
            const dateRegex = /^\d{1,2}[/.-]\d{1,2}[/.-](?:\d{4}|\d{2})$/;
            if (!dateRegex.test(date)) {
              return false;
            }
            return true;
          }
        };

        self.info = {
          loading: false,
          cancel: function() {
            self.info.loading = false;
            $scope.show = false;
          },
          submit: function() {
            self.info.loading = true;
            if (!self.dateInfo.validateDate()) {
              Application.messaging.addMessage({type: 'error', duration: 5, text: 'Must enter a valid completion date'})
              self.info.cancel();
              return;
            }
            submission()
            .then(function(results) {
              self.info.cancel();
              if (results && results.status && results.status === 'success') {
                $scope.postSubmit({});
                Application.messaging.addMessage({type: 'success', text: self.translations[$scope.type + '.manualCompletion.completed'], duration: 5});
                return;
              }

              Application.messaging.addMessage({type: 'error', text: self.translations[$scope.type + '.manualCompletion.error'], duration: 5});
              return;
            }).catch(function(error) {
              self.info.cancel();
              Application.messaging.addMessage({type: 'error', text: self.translations[$scope.type + '.manualCompletion.error'], duration: 5});
              return;
            });
          }
        };

        $translate([
          "assignment.manualCompletion.heading",
          "assignment.manualCompletion.warning",
          "scorm.manualCompletion.heading",
          "scorm.manualCompletion.warning",
          "track.manualCompletion.heading",
          "track.manualCompletion.warning",
          "assignment.manualCompletion.completed",
          "assignment.manualCompletion.error",
          "scorm.manualCompletion.completed",
          "scorm.manualCompletion.error",
          "track.manualCompletion.completed",
          "track.manualCompletion.error"
        ]).then(function (translations) {
          self.translations = translations;
        });

      }],
      controllerAs: 'completion'
    };
  }]);


